import React from 'react';
import { ChevronDown } from 'lucide-react';

export const Hero = () => {
  const scrollToNext = () => {
    const element = document.getElementById('el-cercado');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1465631494067-3e0491e95bd1"
          alt="Manos artesanas trabajando arcilla"
          className="w-full h-full object-cover object-[46%_center] md:object-center"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-earth/60 via-earth/40 to-earth/70" />
      </div>

      {/* Content */}
      <div className="relative h-full flex flex-col items-center justify-center text-center px-6">
        <div className="max-w-4xl animate-fade-in-up">
          <h1 className="display-heading text-5xl md:text-6xl lg:text-7xl text-cal mb-6 leading-tight">
            Quinientos años
            <br />
            <span className="text-ochre-light">moldeando tradición</span>
          </h1>
          <p className="text-lg md:text-xl text-cal/90 font-light max-w-2xl mx-auto leading-relaxed">
            Cinco siglos. Las mismas manos. Las mismas familias. La misma arcilla.
          </p>
        </div>

        {/* Scroll Indicator */}
        <button
          onClick={scrollToNext}
          className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-cal/80 hover:text-cal transition-colors group"
          aria-label="Desplazar hacia abajo"
        >
          <span className="text-sm uppercase tracking-wider font-medium">Conoce El Cercado</span>
          <ChevronDown className="w-6 h-6 animate-bounce" />
        </button>
      </div>
    </section>
  );
};
